// removed by extract-text-webpack-plugin
module.exports = {"root":"transaction_root_bay8h7","timestamp":"transaction_timestamp_2gat57","typeIcon":"transaction_typeIcon_d0wtm0","txHash":"transaction_txHash_bs3s9n","value":"transaction_value_20ynh2","received":"transaction_received_7w4e79","sent":"transaction_sent_7e16bj"};


//////////////////
// WEBPACK FOOTER
// ./packages/page-index/src/accounts/transaction/transaction.scss
// module id = 553
// module chunks = 0